import React, { useEffect, useRef, useState } from "react";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import CreateTriggerBtn from "./CreateTriggerBtn";
import BotStepsModal from "./BotStepsModal";
import PreviousExecutionsModal from "./PreviousExecutions";
import BotStepsEditModal from "./BotStepsEditModal";
import TriggerForm from "./TriggerForm";
import { DataState } from "./../../context/DataProvider";
import BotTest from "./BotTest";
import TriggerDetails from "./TriggerDetails";
import Modal from "../Modal";
import ToggleButton from "./ToggleButton";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { PiCaretDownFill } from "react-icons/pi";
import { FaCheckCircle, FaTimesCircle, FaHourglassHalf } from "react-icons/fa";
import { appImages } from "../../utils/constants";
import useClickOutside from "../../hooks/useClickOutside";
// import { getHistoryWorkflows } from "../../services/history_workflow";

const Trigger = () => {
  const [bookmarksChecked, setBookmarksChecked] = React.useState(true);
  const [urlsChecked, setUrlsChecked] = React.useState(false);
  const [person, setPerson] = React.useState("pedro");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isBotStepsModalOpen, setBotStepsModalOpen] = useState(false);
  const [IsBotStepsEditModalOpen, setIsBotStepsEditModalOpen] = useState(null);
  const [isPreviousExecutionsModalOpen, setPreviousExecutionsModalOpen] = useState(false);
  const [selectedBotId, setSelectedBotId] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const { botsHistory: bots } = DataState();
  const walletAddressRef = useRef(null);
  const { userGoogleId } = DataState();



  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);

    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

    const formattedTime = date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    return `${formattedDate}, ${formattedTime}`;
  };

  // const fetchBots = async () => {
  //   const response = await getHistoryWorkflows(userGoogleId);
  //   const data = await response.json();
  //   setBots(data);
  // };



  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const openBotStepsModal = (botId) => {
    setSelectedBotId(botId);
    setBotStepsModalOpen(botId);
    setDropdownOpen(null);
  };
  const closeBotStepsModal = () => {
    setBotStepsModalOpen(null);
    setIsBotTestModalOpen(null);
    setSelectedBotId(null);
  };

  const openBotStepsEditModal = (botId) => {
    setSelectedBotId(botId);
    setIsBotStepsEditModalOpen(botId);
    setDropdownOpen(null);
  };
  const closeBotStepsEditModal = () => {
    // setBotStepsModalOpen(null);
    setIsBotStepsEditModalOpen(null);
    setSelectedBotId(null);
  };

  const openPreviousExecutionsModal = (botId) => {
    setSelectedBotId(botId);
    setPreviousExecutionsModalOpen(botId);
    setDropdownOpen(null);
  };

  const [isBotTestModalOpen, setIsBotTestModalOpen] = useState(false);
  const openTestBotScreen = (botId) => {
    setSelectedBotId(botId);
    setIsBotTestModalOpen(botId);
    setDropdownOpen(null);
  };

  const closePreviousStepsModal = () => {
    setPreviousExecutionsModalOpen(null);
    setIsBotTestModalOpen(null);
    setSelectedBotId(null);
  };

  const [showDetails, setShowDetails] = useState("");
  const openShowDetails = (botId) => {
    setShowDetails(botId);
    setDropdownOpen(null);
  };

  const toggleDropdown = (botId) => {
    setDropdownOpen((prev) => (prev === botId ? null : botId));
  };

  useClickOutside([walletAddressRef], () => toggleDropdown(null));

  const [copyWorkflow, setCopyWorkflow] = useState(false);
  const [copyWorkflowData, setCopyWorkflowData] = useState(false);

  const handleCopyWorkflow = (item) => {
    setCopyWorkflow(true);
    setCopyWorkflowData(item);
    openModal();
  };
  console.log("bots", bots);

  return (
    <div className="w-full mt-4">
      <div className="mt-5 flex flex-col gap-5 max-h-[calc(100vh-200px)] overflow-y-auto hide-sidebar">
        {" "}
        {/* Set a max height for scrolling */}
        {bots.length > 0 ? (
          bots.map((item) => (
            <div
              key={item.id}
              className="flex flex-col gap-2 relative py-3 px-4 rounded-md border br-2 bg-2 transition-colors duration-150 ease-in-out text-p-text"
            >
              <div className="flex items-center gap-2">
                <div className="flex items-center gap-1">
                  {/* MODIFICATION START: Dynamically render trigger icons */}
                  {Array.isArray(item.trigger) && item.trigger.length > 0 ? (
                    item.trigger.map((triggerNode) => {
                      const triggerKey = triggerNode.data?.triggerOption;
                      // Use appImages to find the correct icon, with a fallback
                      const imageUrl = appImages[triggerKey] || "/assets/logo.png";

                      return (
                        <div
                          key={triggerNode.id} // Use the unique node ID for the key
                          className="flex flex-shrink-0 rounded items-center justify-center w-5 h-5 p-0.5"
                          title={triggerNode.data?.label || triggerKey} // Add a helpful tooltip
                        >
                          <img
                            src={imageUrl}
                            alt={`${triggerKey || "trigger"} icon`}
                          />
                        </div>
                      );
                    })
                  ) : (
                    // Fallback for bots with no triggers defined
                    <div className="flex flex-shrink-0 rounded items-center justify-center w-5 h-5 p-0.5">
                      <img src={"/assets/logo.png"} alt="Trigger icon" />
                    </div>
                  )}
                </div>
                <strong className="flex-1 truncate text-md font-medium">
                  {item.name}
                </strong>
                <div className="flex items-center gap-4 relative z-10 mb-3">
                  {/* <ToggleButton /> */}
                  <DropdownMenu.Root>
                    <DropdownMenu.Trigger asChild>
                      <button
                        type="button"
                        onClick={() => toggleDropdown(item.id)}
                        className="rounded-[3px] text-md font-semibold transition-colors duration-150 ease-in-out disabled:cursor-not-allowed -mr-1 py-1 px-1 border-0 bg-transparent flex items-center text-p-text"
                      >
                        <span className="sr-only">Open workflow settings</span>
                        <PiDotsThreeOutlineVerticalFill className="text-xl" />
                      </button>
                    </DropdownMenu.Trigger>
                    <DropdownMenu.Portal>
                      <DropdownMenu.Content
                        className="DropdownMenuContent text-zinc-200 bg-zinc-900 shadow-lg p-2 border border-zinc-700 rounded-lg overflow-hidden z-20"
                        sideOffset={8}
                      >
                        {[
                          {
                            label: "View Details",
                            onClick: () => openShowDetails(item.id),
                          },
                          // {
                          //   label: "Test Workflow",
                          //   onClick: () => openTestBotScreen(item.id),
                          // },
                          // {
                          //   label: "Advanced Test",
                          //   onClick: () => openBotStepsModal(item.id),
                          // },
                          {
                            label: "Previous Executions",
                            onClick: () => {
                              openPreviousExecutionsModal(item.id);
                              console.log("Previous execution opened");
                            },
                          },
                          // {
                          //   label: "Edit",
                          //   onClick: () => openBotStepsEditModal(item.id),
                          // },
                          // { label: "Advanced Edit" },
                          // {
                          //   label: "Duplicate Workflow",
                          //   onClick: () => handleCopyWorkflow(item),
                          // },
                          { label: "Share" },
                          { label: "Delete" },
                        ].map((item, index) => (
                          <DropdownMenu.Item
                            key={index}
                            className="DropdownMenuItem"
                          >
                            <button
                              onClick={item.onClick}
                              className="block px-5 py-2 text-sm w-full text-left bg-1-hover hover:bg-zinc-800 focus:bg-gray-700 rounded-md transition-all duration-150"
                            >
                              {item.label}
                            </button>
                          </DropdownMenu.Item>
                        ))}
                      </DropdownMenu.Content>
                    </DropdownMenu.Portal>
                  </DropdownMenu.Root>
                </div>
              </div>
              {isBotStepsModalOpen === item.id && (
                <BotStepsModal
                  botId={selectedBotId}
                  onClose={closeBotStepsModal}
                />
              )}
              {IsBotStepsEditModalOpen === item.id && (
                <BotStepsEditModal
                  botId={selectedBotId}
                  onClose={closeBotStepsEditModal}
                />
              )}
              {isPreviousExecutionsModalOpen === item.id && (
                <PreviousExecutionsModal
                  botId={selectedBotId}
                  onClose={closePreviousStepsModal}
                />
              )}

              <Modal
                isOpen={showDetails === item.id}
                title="Details"
                onClose={() => setShowDetails(null)}
              >
                <TriggerDetails item={item} />
              </Modal>
              <div className="flex flex-row flex-wrap gap-4">
                {item.apps_expanded.map((i, index) => (
                  <div
                    key={index}
                    className="bg-zinc-900 rounded-lg px-4 py-3 flex flex-col gap-3"
                  >
                    <div className="flex items-center gap-2">
                      <div
                        key={i.image}
                        className="flex flex-shrink-0 rounded items-center justify-center w-5 h-5 p-0.5 border border-zinc-300 bg-zinc-100"
                      >
                        <img src={i.image} alt="Trigger icon" />
                      </div>
                      <span>{i.label}</span>
                    </div>

                    {i.triggerPhrase && (
                      <div className="flex items-center py-1 px-2 border border-zinc-700 rounded-[4px] bg-zinc-800 text-sm w-fit">
                        <span className="font-semibold">Specific Phrase or Keyword</span>: "
                        {i.triggerPhrase}"
                      </div>
                    )}
                  </div>
                ))}
              </div>
              {item.task_description && (
                <p className="text-sm font-normal text-s-text border br-1 bg-1 px-3 py-2 rounded-xl mt-2">
                  {/* Workflow: {item.task_description} */}
                  <DescriptionToggle item={item} />
                </p>
              )}

              {/* Last Session Field with Dropdown */}
              <div className="mt-2 text-sm font-normal text-s-text border br-1 bg-1 px-3 py-2 rounded-xl">
                <DropdownMenu.Root>
                  <DropdownMenu.Trigger asChild>
                    <button className="flex items-center justify-between w-full">

                      <div className="flex items-center gap-2">
                        Last Execution:{" "}
                        {formatTimestamp(item.latestSession.timestamp)}

                        <PiCaretDownFill className="text-lg ml-2" />
                      </div>
                      {/* Display status icon based on latestSession.status */}
                      {item.latestSession.status === "success" && (
                        <FaCheckCircle className="text-green-500 text-lg " title="Success" />
                      )}
                      {item.latestSession.status === "failed" && (
                        <FaTimesCircle className="text-red-500 text-lg " title="Failed" />
                      )}
                      {item.latestSession.status === "pending" && (
                        <FaHourglassHalf className="text-yellow-500 text-lg " title="Pending" />
                      )}
                      {item.latestSession.status === "running" && (
                        <div className="w-6 h-6 border-2 border-yellow-500 border-t-transparent rounded-full animate-spin" />
                      )}
                    </button>
                  </DropdownMenu.Trigger>
                  <DropdownMenu.Portal>
                    <DropdownMenu.Content
                      className="DropdownMenuContent text-zinc-200 bg-zinc-900 shadow-lg p-2 border border-zinc-700 rounded-lg overflow-hidden z-20"
                      sideOffset={8}
                    >
                      <div className="px-4 py-2">
                        <p className="text-md font-semibold">Execution Details:</p>
                        <div className="mt-2">
                       
                          <p>
                            <strong>Valid:</strong>{" "}
                            {item.latestSession.valid ? "Yes" : "No"}
                          </p>
                          <p>
                            <strong>Timestamp:</strong>{" "}
                            {formatTimestamp(item.latestSession.timestamp)}
                          </p>
                          <p>
                            <strong>Status:</strong>{" "}
                            {item.latestSession.status.charAt(0).toUpperCase() + item.latestSession.status.slice(1)}
                          </p>
                        </div>
                      </div>
                    </DropdownMenu.Content>
                  </DropdownMenu.Portal>
                </DropdownMenu.Root>
              </div>
            </div>
          ))
        ) : (
          <div className="flex flex-col gap-5 items-center justify-center h-96 bg-zinc-900 rounded-lg p-4 border border-zinc-700 w-full max-w-2xl mx-auto text-center">
            <span className="text-zinc-400 text-sm sm:text-base">
              No workflows created yet
            </span>
            <span className="text-zinc-100 text-lg sm:text-xl font-semibold">
              Start creating with your first workflow
            </span>
            <CreateTriggerBtn onClick={openModal} />
          </div>
        )}
      </div>

      <TriggerForm
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        copyWorkflow={copyWorkflow}
        copyWorkflowData={copyWorkflowData}
      />
    </div>
  );
};

export default Trigger;

export const triggerDatabase = [
  {
    id: 1,
    name: "When I message the assistant",
    image: "https://oqlous.inqbator.in/assets/oqlous.svg",
  },
  {
    id: 2,
    name: "Gmail",
    image:
      "https://res.cloudinary.com/dsguoq6ad/image/upload/v1726228561/mentorEducationImages/wbenqxucyj7mh0vsec5f.png",
  },
];

const DescriptionToggle = ({ item }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Function to toggle the expanded state
  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  // Truncate the description to 200 characters
  const truncatedDescription =
    item.task_description.length > 400
      ? item.task_description.substring(0, 400) + "..."
      : item.task_description;

  return (
    <>
      Workflow:
      {isExpanded ? " " + item.task_description : " " + truncatedDescription}
      {item.task_description.length > 400 && (
        <button
          onClick={toggleDescription}
          className="ml-2 text-xs text-zinc-400 hover:underline focus:outline-none"
        >
          {isExpanded ? "Show Less" : "Show More"}
        </button>
      )}
    </>
  );
};